import { PurchaseConfirmation } from 'components';

const LeisureConfirmationStep = () => {
  return (
    <div className="lg:grow">
      <PurchaseConfirmation pageType="leisure" />
    </div>
  );
};

export default LeisureConfirmationStep;
